import { at } from 'lodash'
import generateItemUid from './generate-item-uid'

export default (product) => {
    if(!product) { return null}
    //ALL ATTRIBUTES
    const attributes = []
    const optionsGrouped = {}
    for(let i = 0; i < product.attribute_options.length; i++) {
        const option = product.attribute_options[i]
        if(!optionsGrouped[`attr_${option.attribute_id}`]) {
            optionsGrouped[`attr_${option.attribute_id}`] = []
        }
        optionsGrouped[`attr_${option.attribute_id}`].push(option)
    }

    const availableOptions = {}
    for(let i = 0; i < product.attributes.length; i++) {
        const attribute = product.attributes[i]
        attribute.options = optionsGrouped[`attr_${attribute.id}`] || []
        attributes.push(attribute)

        if(!availableOptions[attribute.slug]) {
            availableOptions[attribute.slug] = []
        }

        availableOptions[attribute.slug] = attribute.options.map(opt => opt.slug)
    }

    const variations = product.variations.map(item => {
        if(item.price > 0)
        {
            const options = {}
            for(let i = 0; i < item.attribute_options.length; i++) {
                const attOption = item.attribute_options[i]
                options[attOption.attribute.slug] = attOption.slug
            }

            return {...item, ...{uid: generateItemUid({attributes: options})}}
        }
        else
        {
            return null;
        }
    }).slice().filter(item => item !== null);

    //ALL ATTACHMENTS
    let variantAttachments = []

    if(product.type === 'variable') {
        for(let i = 0; i < variations.length; i++) {
            if(variations[i].main_image) {
                variantAttachments.push({...variations[i].main_image, ...{uid: variations[i].uid}, ...{position: variations[i].position}})
            }
        }
    } else {
        for(let i = 0; i < product.variant_images.length; i++) {
            if(product.variant_images[i].image) {
                variantAttachments.push({...product.variant_images[i].image, ...{uid: product.variant_images[i].uid}})
            }
        }
    }

    if(product.type === 'variable' && variantAttachments.length > 0) {
        const groupedData = {};
        variantAttachments.forEach(item => {

        if (!groupedData[item.id]) {
            groupedData[item.id] = { ...item, uid: [] };
        }
        if(item.uid)
            groupedData[item.id].uid.push(item.uid);


        });

        variantAttachments = Object.values(groupedData);
    }

    let attachments = [];

    if(variantAttachments.length > 0)
    {
        if(product.type === 'variable'){

            product.main_image.uid = [product.main_image.uid];

            const colorAttr = product.attributes.find(attr => attr.slug === "color");
            const textureAttr = product.attributes.find(attr => attr.slug === "texture");

            if(colorAttr && colorAttr.options.length > 1)
            {
                let namesArray = colorAttr.options.map(item => item.name);

                let combinations = [];
                if(textureAttr && textureAttr.options.length > 1)
                {
                    let textureNamesArray = textureAttr.options.map(item => item.name);

                    namesArray.forEach(firstItem => {
                        textureNamesArray.forEach(secondItem => {
                            combinations.push(`${secondItem} - ${firstItem}`);
                        });
                    });

                    namesArray = combinations;
                }

                variantAttachments = variantAttachments.slice().sort((a, b) => {
                    const nameA = a.name;
                    const nameB = b.name;
                    
                    const indexA = nameA ? namesArray.findIndex(name => nameA.includes(name)) : null;
                    const indexB = nameB ? namesArray.findIndex(name => nameB.includes(name)) : null;

                    // Compare based on the order of names
                    return indexA - indexB;
                });
            }
            else
            {
                variantAttachments = variantAttachments.slice().sort((a, b) => a.position - b.position);
            }
        }
        attachments = attachments = [...[product.main_image], ...variantAttachments]
    }
    else if(product.attachments.length > 0)
    {
        attachments = [...[product.main_image], ...product.attachments]
    }
    else
    {
        if(product.type === 'variable' && !attachments.find(i => product.main_image?.path === i.path)) {
            product.main_image.uid = [product.main_image.uid];
            attachments = [...[product.main_image], ...attachments]
        }

        if ((product.type !== 'variable' || !attachments.length) ) {
            attachments = [...[product.main_image], ...attachments]
        }
    }
    const item = {
        ...product,
        ...{
            id: product.id,
            title: product.title,
            publish_url: product.publish_url,

            sku: product.sku,
            sku_pattern: product.sku_pattern,

            main_image: product.main_image,
            fillPrice: !!product.fill_price,

            min_quantity: product.min_quantity,
            max_quantity: product.max_quantity,
            grouped_product: product.grouped_product,
            group_of: product.group_of,

            area_calculation: !!product.area_calculation,
            enable_functionality_for_admin: !!product.enable_functionality_for_admin,
            allow_combination: !!product.allow_combination,
            width: product.width,
            length: product.length,
            height: product.height,
            weight: product.weight,

            tabs: product.tabs || [],
            categories: product.categories || [],
            attributes: attributes,
            availableOptions: availableOptions,
            defaultOptions: product.default_attributes || {},
            attachments: attachments,
            variations: variations,

            type: product.type,
            price: product.price,
            price_label: product.price_label,
            image: product.main_image,
            units: product.units,
            content: product.content,
            excerpt: product.excerpt,
            description: product.description,
            threshold_quantity: product.threshold_quantity,
            threshold_enabled: product.threshold_enabled,
        }
    }

    return item
}
